module.exports = __webpack_public_path__ + "static/media/black3.2ad40e60.png";